import React from 'react'
import styled from 'styled-components'
import { colors } from 'app-v2/design-systems/theme/colors'
import { Icon } from 'app-v2/shared/features/icon'

type Props = {
    iconCode: string,
    iconUrl?: string,
    label?: string,
    color?: string,
    style?: Object
}

/* Do not delete */
const NavigationItemIcon = (props: Props) => {
    const {
        iconCode,
        iconUrl,
        label,
        color = colors.bbqBrown,
        ...otherProps
    } = props
    if (!iconCode && !iconUrl) {
        return null
    }
    const contributedIcon = iconUrl && (
        <img src={iconUrl} alt={label} width="24" height="24" />
    )
    if (contributedIcon) {
        return <IconContainer {...otherProps}>{contributedIcon}</IconContainer>
    } else if (iconCode) {
        return (
            <IconContainer {...otherProps}>
                <Icon code={iconCode} color={color} />
            </IconContainer>
        )
    } else {
        return null
    }
}

const IconContainer = styled.span`
    font-size: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    > img {
        width: 100%;
        height: auto;
    }
`

export { NavigationItemIcon }
